/* @flow */
import gql from 'graphql-tag';
import type {FilterGroupType} from '../components/MoreFilters/MoreFilters';

type FilteredCountQueryResults = {
    filterGroups?: FilterGroupType[],
    hitCollection: {
        total: number
    }
};

export type FilteredCountQueryResponseData = {
    results: FilteredCountQueryResults,
    error?: Error,
    loading: boolean
};

export const fragments = {
    results: gql`
        fragment FilterCountsResults on Results {
            hitCollection {
                total
            }
            filterGroups {
                name
                key
                filters {
                    name
                    key
                    count
                    checked
                    description
                }
            }
        }
    `
};

const filteredCountQuery = gql`
    query FilterCountQuery($params: ResultsParams) {
        results(params: $params) {
            id
            ...FilterCountsResults
        }
    }
    ${fragments.results}
`;

export default filteredCountQuery;
